<button
  shrdUicButton
  variant="tertiary"
  class="user-info-button"
  [ngClass]="{ selected: isSelected }"
  [disabled]="disabled || isSelected"
  (click)="showAccountDetails.emit()"
  *ngIf="accountIsSelectable; else plainUserInfo"
>
  <ng-container *ngTemplateOutlet="userInfoContents"></ng-container>
</button>

<ng-template #plainUserInfo>
  <div class="justify-content-between m-0 py-1">
    <ng-container *ngTemplateOutlet="userInfoContents"></ng-container>
  </div>
</ng-template>

<ng-template #userInfoContents>
  <div class="no-truncate user-info text-start">
    <p *ngIf="showUserName" class="text-bold user-name-wrapper mb-2">
      <shrd-pf-ui-header-user-name
        [user]="userAccount.contact"
        [omitTitle]="omitUserTitle"
      ></shrd-pf-ui-header-user-name>
    </p>
    <ng-container *ngIf="userAccount.formatted as formatted; else companyNameOnly">
      <ng-container *ngFor="let line of formatted; first as isFirst">
        <p [class.text-bold]="isFirst">
          {{ line }}
        </p>
      </ng-container>
    </ng-container>
    <ng-template #companyNameOnly>
      <ng-container *ngIf="userAccount?.companyName as companyName">
        <p class="text-bold">
          {{ 'header.account.company' | i18next }}
        </p>
        <p>
          {{ companyName }}
        </p>
      </ng-container>
    </ng-template>
    <ng-container *ngIf="userAccount?.originId as originId">
      <p class="mt-1">
        <strong>{{ 'header.account.accountNumber' | i18next }}</strong>
      </p>
      <p>{{ originId }}</p>
    </ng-container>
  </div>
</ng-template>
